/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Failed_GenericInputs */



/**
* | output |
* | --- |
* | "Error exporting audio description" |
*
* @param {Audio_Description_Export_Failed_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_failed_generic = /** @type {((inputs?: Audio_Description_Export_Failed_GenericInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Failed_GenericInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de l'exportation de la description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Exportieren der Audiobeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante l'esportazione della descrizione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при экспорте аудиоописания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al exportar la descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出音频描述时出错")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声説明のエクスポート中にエラーが発生しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण निर्यात करने में त्रुटि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao exportar a descrição de áudio")
	return /** @type {LocalizedString} */ ("Error exporting audio description")
});